import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import ServicesSection from '../components/ServicesSection';

const ServicesContainer = styled.div`
  padding-top: 120px;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, var(--primary-color) 0%, #e67e00 100%);
  color: var(--white-color);
  padding: 100px 0;
  text-align: center;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ServicesPage = () => {
  return (
    <ServicesContainer>
      <HeroSection>
        <Container>
          <HeroTitle>Hizmetlerimiz</HeroTitle>
          <HeroSubtitle>
            Besi çiftliğimizde sunduğumuz kapsamlı hizmetler
          </HeroSubtitle>
        </Container>
      </HeroSection>
      
      <ServicesSection />
    </ServicesContainer>
  );
};

export default ServicesPage; 